import axios from "axios";
import { cmsEnv, cmsHeaders } from "../exports/exports";

export const fetchgalleryHeader = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/${process.env.REACT_APP_cmsProjectId}/gallery-header`,
      {
        headers: {
          ...cmsHeaders,
          ...cmsEnv,
        },
      },
    );
    return response.data.slice(-1);
  } catch (error) {
    console.error("Server Error");
  }
};

// export const fetchgalleryImages = async () => {
//   try {
//     const response = await axios.get(
//       `${process.env.REACT_APP_cmsUrl}/content-manager/${process.env.REACT_APP_cmsProjectId}/galley-album`,
//       {
//         headers: {
//           ...cmsHeaders,
//           ...cmsEnv,
//         },
//       },
//     );
//     return response.data;
//   } catch (error) {
//     console.error("Server Error");
//   }
// };

export const fetchgalleryImages = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/${process.env.REACT_APP_cmsProjectId}/images?sort=sort_order:asc`,
      {
        headers: {
          ...cmsHeaders,
          ...cmsEnv,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Server Error");
  }
};
